import React, { forwardRef } from "react";
import Select from "../../AtomicSelect";
import { css, cx } from "emotion";
import ErrorMessage from "../ErrorMessage";
import { defaultStyle } from "./style";

const SelectFormRef = ({ errorMessage, hasError, innerRef, helperText, icon, ...rest }) => {
	return (
		<div
			className={cx(
				css`
					${defaultStyle}
				`,
				"form-group",
				{ "has-error": hasError }
			)}
		>
			<Select {...rest} ref={innerRef} hasError={hasError} />
			{errorMessage && hasError && <ErrorMessage>{errorMessage}</ErrorMessage>}
			{helperText}
		</div>
	);
};

const SelectForm = forwardRef((props, ref) => <SelectFormRef {...props} innerRef={ref} />);

export default SelectForm;
